// mapping actions

import { Action } from '@ngrx/store';
import { Part, MappingOptions } from '@usimweb/core/models';

// project id
// version id
export const ADD_INFO = '[Viewer] Add info';
export const ADD_MAPPING_OPS = '[Viewer] Add Mapping options';

export const ADD_PART = '[Viewer] Add Part';
export const DELETE_PART = '[Viewer] Delete Part';

export const ADD_RESULT = '[Viewer] Add Result';
export const UPDATE_SCALING = '[Viewer] Add Result';
export const Update_SCALER = '[Viewer] Update scaler';
export const UPDATE_VECTOR = '[Viewer] Update vector';

export const CLEAR_VIEWER = '[Viewer] Clear viewer';

//TODO add action perform mapping to see what data was send to api

export class AddInfo implements Action {
  readonly type = ADD_INFO;
  constructor(public payload: any) {}
}

export class AddMappingOpts implements Action {
  readonly type = ADD_MAPPING_OPS;
  constructor(public payload: MappingOptions) {}
}

export class AddPart implements Action {
  readonly type = ADD_PART;
  constructor(public payload: Part[]) {}
}

export class AddResult implements Action {
  readonly type = ADD_RESULT;
  constructor(public payload: any) {}
}

export class UpdateScaling implements Action {
  readonly type = ADD_RESULT;
  constructor(public payload: any) {}
}

export class UpdateScalar implements Action {
  readonly type = ADD_RESULT;
  constructor(public payload: any) {}
}

export class UpdateVector implements Action {
  readonly type = ADD_RESULT;
  constructor(public payload: any) {}
}

export class DeletePart implements Action {
  readonly type = DELETE_PART;
  constructor(public payload: number) {}
}

export class ClearViewer implements Action {
  readonly type = CLEAR_VIEWER;
}

export type ViewerActions = AddInfo | AddMappingOpts | AddPart | AddResult | DeletePart | ClearViewer;
